import { render, staticRenderFns } from "./ProductFormTabPhotos.vue?vue&type=template&id=52b6d83a&scoped=true"
import script from "./ProductFormTabPhotos.vue?vue&type=script&lang=js"
export * from "./ProductFormTabPhotos.vue?vue&type=script&lang=js"
import style0 from "./ProductFormTabPhotos.vue?vue&type=style&index=0&id=52b6d83a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b6d83a",
  null
  
)

export default component.exports